import { useSearchParams } from 'react-router';
import './ConfirmationPage.css';
import { useGetOrderNumberMutation } from '../../services/api';
import { useEffect } from 'react';
import LoadingSpinner from '../loadingSpinner/LoadingSpinner';

export default function ConfirmationPage() {
    const [ searchParams ] = useSearchParams();

    const stripeSessionId = searchParams.get('session_id');

    const [ getOrderNumber, { data: orderNumberData, isLoading: loadingOrderNumber } ] = useGetOrderNumberMutation();

    useEffect(() => {
        async function fetchOrderNumber() {
            if (stripeSessionId) {
                await getOrderNumber(stripeSessionId).unwrap();
            }
        }
        fetchOrderNumber();
    }, [getOrderNumber, stripeSessionId]);

    if (loadingOrderNumber || !orderNumberData) return <div className="confirmationPage"><LoadingSpinner /></div>

    return (
        <div className="confirmationPage">
            <section className="confirmationMessage">
                <h2>Thank you for letting us be a part of your adventures!</h2>
                <p>Your order number is: <span className="orderNumber">{orderNumberData.orderNumber}</span></p>
                <p>Use this number if you need to contact us about your order.</p>
                <p>Your order has been received and is being processed. You will receive an email confirmation shortly.</p>
            </section>
        </div>
    )
}